<template>
  <div :class="{/* 'notification-disabled': notification.is_disabled*/ }" @click="openNotification(notification.deeplink)">
    <notification-image :image="notification.image" :is-read="notification.is_read" />
    <div class="notification-info">
      <div class="notification-info-text" v-html="notification.text" />
      <div class="notification-info-date">
        {{ formattedDate(notification.datetime) }}
      </div>
      <div class="notification-info-border" />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import NotificationImage from "./NotificationImage";

export default {
  name: "NotificationContent",
  components: {NotificationImage},
  props: {
    notification: {
      type: Object,
      default: () => {}
    }
  },

  methods: {
    openNotification(link) {
      window.open(link)
    },

    formattedDate(date) {
      return moment(date).format('DD MMM, YYYY hh:mm a');
    }
  }
}
</script>

<style scoped lang="scss">
.notification-disabled {
  pointer-events: none;
  .notification-image {
    opacity: 0.6;
  }
  .notification-info {
    &-text {
      opacity: 0.6;
    }
    &-date {
      opacity: 0.6;
    }
  }
  &:hover {
    background: transparent;
    cursor: default;
  }
}
.notification {
  display: flex;
  padding: 15px 40px;
  transition: .2s;
  align-items: center;

  &:hover {
    background: #F7F7F7;
    cursor: pointer;
    .notification-info-border {
      opacity: 0;
    }
  }
  &-info {
    width: 100%;
    position: relative;
    &-text {
      margin-bottom: 5px;
      font-weight: 400;
      font-size: 14px;
      line-height: 19px;
      color: #1E2021;
    }
    &-date {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #4D4D4D;
    }
    &-border {
      width: 100%;
      height: 1px;
      position: absolute;
      bottom: -15px;
      background: #E5E5E5;
      transition: .2s;
    }
  }
}
</style>
